/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Local_Carriage_TrackInputs */



/**
* | output |
* | --- |
* | "Caption track" |
*
* @param {Embed_Captions_Local_Carriage_TrackInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_local_carriage_track = /** @type {((inputs?: Embed_Captions_Local_Carriage_TrackInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Local_Carriage_TrackInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("piste de sous-titrage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelspur")
	if (locale === "it") return /** @type {LocalizedString} */ ("Traccia sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Субтитры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pista de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕トラック")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन ट्रैक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Legenda da faixa")
	return /** @type {LocalizedString} */ ("Caption track")
});